module.exports = __webpack_public_path__ + "img/bg5.bf1a8e23.png";